import { useState } from "react";
import { BRAND } from "@/lib/behot";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";

export function WithdrawalForm() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    orderRef: "",
    amount: "",
    reason: "",
  });
  const [sent, setSent] = useState(false);
  const set = (k: keyof typeof form) => (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
    setForm((f) => ({ ...f, [k]: e.target.value }));

  function submit(e: React.FormEvent) {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim() || !form.orderRef.trim()) {
      toast.error("Name, email and order/invoice number are required.");
      return;
    }
    const body = [
      `I hereby give notice that I withdraw from my contract with ${BRAND.operator} (${BRAND.domain}).`,
      "",
      `Name: ${form.name}`,
      `Email on account: ${form.email}`,
      `Order / invoice number: ${form.orderRef}`,
      `Amount: ${form.amount || "n/a"}`,
      `Notes: ${form.reason || "n/a"}`,
      "",
      `Date: ${new Date().toLocaleDateString("en-GB")}`,
    ].join("\n");
    window.location.href = `mailto:support@${BRAND.domain}?subject=${encodeURIComponent(
      `Right of withdrawal ${form.orderRef}`,
    )}&body=${encodeURIComponent(body)}`;
    setSent(true);
    toast.success("Withdrawal notice prepared, send the email to complete it.");
  }

  return (
    <section id="form" className="mt-10 rounded-2xl border bg-card p-6">
      <h2 className="font-display text-xl font-bold">Model withdrawal form</h2>
      <p className="mt-2 text-sm text-muted-foreground">
        Complete this form to give notice of withdrawal. Wallet top-ups and unused Heat are not
        eligible.
      </p>
      <form onSubmit={submit} className="mt-5 grid gap-4 sm:grid-cols-2">
        <div className="space-y-1.5">
          <Label htmlFor="wd-name">Full name</Label>
          <Input id="wd-name" value={form.name} onChange={set("name")} placeholder="Jane Doe" />
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="wd-email">Account email</Label>
          <Input id="wd-email" type="email" value={form.email} onChange={set("email")} placeholder="you@example.com" />
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="wd-order">Order / invoice number</Label>
          <Input id="wd-order" value={form.orderRef} onChange={set("orderRef")} placeholder="INV-000123" />
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="wd-amount">Amount (optional)</Label>
          <Input id="wd-amount" value={form.amount} onChange={set("amount")} placeholder="US$25.00" />
        </div>
        <div className="space-y-1.5 sm:col-span-2">
          <Label htmlFor="wd-reason">Additional details (optional)</Label>
          <Textarea id="wd-reason" rows={4} value={form.reason} onChange={set("reason")} placeholder="Anything that helps us locate the transaction." />
        </div>
        <div className="sm:col-span-2">
          <Button type="submit">Send withdrawal notice</Button>
          {sent ? (
            <p className="mt-2 text-xs text-muted-foreground">
              If your mail app did not open, email support@{BRAND.domain} with the details above.
            </p>
          ) : null}
        </div>
      </form>
    </section>
  );
}
